import React, { createContext, useReducer, useState, useEffect } from 'react';
import { shallowEqual, useSelector } from "react-redux";
import * as _ from "lodash";
import { verificarEntero } from '../funciones/validacionDNIS';
//ISO PAISES/PROVINCIAS
import Countries from '../../../../_metronic/countries/Countries';
export const PreInscripcionUIContext = createContext();

export const PreInscripcionUIConsumer = PreInscripcionUIContext.Consumer;


//Formateo loas paises a array
const paises = Countries();

//SE FEFINE EL OBJETO DOMICILIO PARA INCLUIR DENTRO DE PERSONA Y DIFERENCIAR LUGAR DE NACIMIENTO
function Domicilio(calle = "", numero = "", piso = "", dpto = "", departamento = "", localidad = "", domicilioId = 0) {
  this.calle = calle;
  this.numero = numero;
  this.piso = piso;
  this.dpto = dpto;
  this.departamento = departamento;
  this.localidad = localidad;
  this.domicilioId = domicilioId;
};

//SE DEFINE EL OBJETO DOCUMENTACION
function Documentacion(sexo = "", documentoNumero = "") {
  this.sexo = sexo;
  this.documentoNumero = documentoNumero;
};

//SE DEFINE EL OBJETO DATOS PERSONALES
function DatosPersonales(nombre = "", apellido = "", fechaNacimiento = new Date(), pais = 10, provincia = 6, localidad = "") {
  this.nombre = nombre;
  this.apellido = apellido;
  this.fechaNacimiento = fechaNacimiento;
  this.pais = pais;
  this.provincia = provincia;
  this.localidad = localidad;
};

//SE DEFINE EL OBJETO PERSONA
function Persona(id = null, sexo = "", documentoNumero = "", nombre = "", apellido = "",
  fechaNacimiento = new Date(), edad = "", pais = 10, provincia = 6, localidad = "",
  registroCivilvalidacion = false, validadoPorElRegistroCivil = false, domicilio = new Domicilio(),
  vinculo = "", vinculoId = 0, email = "", telefono = "", personaRegistroCivilId = 0) {
  Documentacion.call(this, sexo, documentoNumero);
  DatosPersonales.call(this, nombre, apellido, fechaNacimiento, pais, provincia, localidad)
  this.domicilio = domicilio;
  this.registroCivilvalidacion = registroCivilvalidacion;
  this.validadoPorElRegistroCivil = validadoPorElRegistroCivil;
  this.id = id;
  this.vinculo = vinculo;
  this.vinculoId = vinculoId;
  this.email = email;
  this.telefono = telefono;
  this.personaRegistroCivilId = personaRegistroCivilId;
  this.edad = edad;
};

//SE FEFINE EL OBJETO APISRANTE HEREDANDO PROPIEDADES DE PERSONA
function Aspirante(id = null, inscripcionVinculadaId = null, inscripcionVinculadaNumero = "", sexo = "", documentoNumero = "", nombre = "", apellido = "", 
  fechaNacimiento = new Date(), edad = "", pais = 10, provincia = 6, localidad = "", registroCivilvalidacion = false,
  domicilio = new Domicilio(), vinculo = "", vinculoId = 0, email = "", telefono = "",
  personaRegistroCivilId = 0, inscripcionNumero = "", inscripcionId = 0, validadoPorElRegistroCivil = false) {
  Persona.call(this, id, sexo, documentoNumero, nombre, apellido, fechaNacimiento, edad, pais, provincia, localidad, registroCivilvalidacion,
    validadoPorElRegistroCivil, domicilio, vinculo, vinculoId, email, telefono, personaRegistroCivilId);

  this.inscripcionNumero = inscripcionNumero;
  this.inscripcionId = inscripcionId;
  this.inscripcionVinculadaNumero = inscripcionVinculadaNumero;
  this.inscripcionVinculadaId = inscripcionVinculadaId;
};

//SE FEFINE EL OBJETO RESPONSABLE HEREDANDO PROPIEDADES DE PERSONA
function Responsable(id = null, aspiranteResponsableId = null, sexo = "", documentoNumero = "",
  nombre = "", apellido = "", fechaNacimiento = new Date(), edad = "",
  pais = 10, provincia = 6, localidad = "", registroCivilvalidacion = false, validadoPorElRegistroCivil = false, domicilio = new Domicilio(),
  vinculo = "", vinculoId = 0, email = "", telefono = "", personaRegistroCivilId = 0
) {
  Persona.call(this, id, sexo, documentoNumero, nombre, apellido, fechaNacimiento, edad, pais, provincia, localidad, registroCivilvalidacion, validadoPorElRegistroCivil,
    domicilio, vinculo, vinculoId, email, telefono, personaRegistroCivilId);
  this.aspiranteResponsableId = aspiranteResponsableId;
};

//SE DEFINE EL OBJETO NIVEL DE ENSEÑANZA
function NivelEnseñanza(nivel = "", grado = "") {
  this.nivel = nivel;
  this.grado = grado;
};

//SE DEFINE EL OBJETO EXTRAS
function Extras(fueEstatal = false, fueAbanderaro = false, establecimientoBandera = "", establecimientoEstatal = "") {
  this.fueEstatal = fueEstatal;
  this.fueAbanderaro = fueAbanderaro;
  this.establecimientoBandera = establecimientoBandera;
  this.establecimientoEstatal = establecimientoEstatal;
};

//SE DEFINE EL OBJETO ESTABLECIMIENTO
/*NO SE USA DE MOMENTO
function Establecimiento(nombre = "", direccion = "", barrio = "", telefono = "", vacantes = "", listaEspera = "") {
  this.nombre = nombre;
  this.direccion = direccion;
  this.barrio = barrio;
  this.telefono = telefono;
  this.vacantes = vacantes;
  this.listaEspera = listaEspera;
};
*/

//VARIABLES PARA REDUCER DATOS INSCRIPCIONES
const inscripcionesBaseReducer = [];
const InscripcionesReducer = (state, action) => {
  switch (action.type) {
    case 'guardarInscripcion':
      state.push(action.payload);
      return state;

    case 'reiniciarDatos':
      state = inscripcionesBaseReducer;
      return state;

    case 'cargarInscripciones':
      state = action.payload;
      return state;

    default:
      return state;
  }
}

//VARIABLES PARA REDUCER DATOS PERSONALES
const aspirante = new Aspirante();
const responsables = [];
const nivelEnseñanza = new NivelEnseñanza();
const establecimientos = [];
const numeroVinculacion = "";
const extras = new Extras();
const responsablePrincipalPosicion = 0;


const datosPersonalesBaseReducer = {
  //OBJETO QUE GUARDARA PROPIEDADES DEL ASPIRANTE
  aspirante,
  //ARRAY DE OBJETOS QUE GUARDARA UNA LISTA DE RESPONSABLES CON SUS PROPIEDADES
  responsables,
  //LA POSICION DEL RESPONSABLE PRINCIPAL EN EL ARRRAY DE RESPONSABLES
  responsablePrincipalPosicion,
  //OBJETO QUE GUARDA EL NIVEL SELECCIONADO PARA INSCRIPCION
  nivelEnseñanza,
  //ARRAY DE OBJETOS QUE GUARDA LOS ESTABLECIMIENTOS DE INSCRIPCION
  establecimientos,
  //NUMERO PARA VINCULAR OTRA INSCRIPCION
  numeroVinculacion,
  //OBJETO QUE GUARDA INFORMACION EXTRA
  extras
};


const DatosPersonalesReducer = (state, action) => {
  //NO SE USA Object.assign XQ SI VIENEN VALORES NO DESEADOS LOS GUARDA.
  switch (action.type) {

    /*GUARDAR INFO*/
    case 'guardarAspiranteDocumentacion':
      state.aspirante.sexo = action.payload.sexo;
      state.aspirante.documentoNumero = action.payload.documentoNumero;
      state.aspirante.registroCivilvalidacion = action.payload.registroCivilvalidacion;
      state.aspirante.personaRegistroCivilId = action.payload.personaRegistroCivilId;
      //console.log(state);
      return state;

    case 'guardarAspiranteDatosPersonales':
      state.aspirante.nombre = action.payload.nombre;
      state.aspirante.apellido = action.payload.apellido;
      state.aspirante.fechaNacimiento = action.payload.fechaNacimiento;
      state.aspirante.pais = action.payload.pais;
      state.aspirante.provincia = action.payload.provincia;
      state.aspirante.localidad = action.payload.localidad;
      //console.log(state);
      return state;

    case 'guardarAspiranteDomicilio':
      state.aspirante.domicilio.calle = action.payload.calle;
      state.aspirante.domicilio.numero = action.payload.numero;
      state.aspirante.domicilio.piso = action.payload.piso;
      state.aspirante.domicilio.dpto = action.payload.dpto;
      state.aspirante.domicilio.departamento = action.payload.departamento;
      state.aspirante.domicilio.localidad = action.payload.localidad;
      state.aspirante.domicilio.domicilioId = action.payload.domicilioId;
      //console.log(state);
      return state;

    case 'mismoDomicilioAspirante':
      state.responsables[action.payload.posicion].domicilio = state.aspirante.domicilio;
      //console.log(state);
      return state;

    case 'guardarResponsableDocumentacion':
      if (state.responsables.length < action.payload.posicion + 1) {
        const responsable = new Responsable();
        state.responsables[action.payload.posicion] = responsable;
      };
      if (state.responsables.length === 1) {
        state.responsables[0].principal = true;
      };

      state.responsables[action.payload.posicion].sexo = action.payload.sexo;
      state.responsables[action.payload.posicion].documentoNumero = action.payload.documentoNumero;
      state.responsables[action.payload.posicion].registroCivilvalidacion = action.payload.registroCivilvalidacion;
      state.responsables[action.payload.posicion].personaRegistroCivilId = action.payload.personaRegistroCivilId;
      state.responsables[action.payload.posicion].validadoPorElRegistroCivil = action.payload.validadoPorElRegistroCivil;
      //console.log(state);
      return state;

    case 'guardarResponsableDatosPersonales':
      state.responsables[action.payload.posicion].nombre = action.payload.nombre;
      state.responsables[action.payload.posicion].apellido = action.payload.apellido;
      state.responsables[action.payload.posicion].vinculo = action.payload.vinculo;
      state.responsables[action.payload.posicion].vinculoId = action.payload.vinculoId;
      state.responsables[action.payload.posicion].fechaNacimiento = action.payload.fechaNacimiento;
      state.responsables[action.payload.posicion].pais = action.payload.pais;
      state.responsables[action.payload.posicion].provincia = action.payload.provincia;
      state.responsables[action.payload.posicion].localidad = action.payload.localidad;
      state.responsables[action.payload.posicion].email = action.payload.email;
      state.responsables[action.payload.posicion].telefono = action.payload.telefono;
      state.responsables[action.payload.posicion].id = action.payload.id;
      state.responsables[action.payload.posicion].aspiranteResponsableId = action.payload.aspiranteResponsableId;
      //console.log(state);
      return state;

    case 'guardarResponsableDomicilio':
      state.responsables[action.payload.posicion].domicilio.calle = action.payload.calle;
      state.responsables[action.payload.posicion].domicilio.numero = action.payload.numero;
      state.responsables[action.payload.posicion].domicilio.piso = action.payload.piso;
      state.responsables[action.payload.posicion].domicilio.dpto = action.payload.dpto;
      state.responsables[action.payload.posicion].domicilio.departamento = action.payload.departamento;
      state.responsables[action.payload.posicion].domicilio.localidad = action.payload.localidad;
      state.responsables[action.payload.posicion].domicilio.domicilioId = action.payload.domicilioId;
      //console.log(state);
      return state;

    case 'guardarResponsablePrincipalPosicion':
      state.responsablePrincipalPosicion = action.payload.posicion;
      return state;

    case 'guardarNivelEnseñanza':
      state.nivelEnseñanza.nivel = action.payload.nivel;
      state.nivelEnseñanza.grado = action.payload.grado;
      //console.log(state);
      return state;

    case 'guardarEstablecimientos':
      state.establecimientos = action.payload.establecimientos;
      //console.log(state);
      return state;

    case 'guardarExtras':
      state.extras.fueEstatal = action.payload.fueEstatal;
      state.extras.fueAbanderaro = action.payload.fueAbanderaro;
      state.extras.establecimientoBandera = action.payload.establecimientoBandera;
      state.extras.establecimientoEstatal = action.payload.establecimientoEstatal;
      //console.log(state);
      return state;
    /*GUARDAR INFO*/

    /*OTRAS ACCIONES*/
    case 'quitarResponsable':
      state.responsables.splice(action.payload.posicion, 1);
      //console.log(state);
      return state;
    case 'verResponsables':
      return state.responsables;

    case 'reiniciarDatos':
      state = {
        aspirante: new Aspirante(),
        responsables: [],
        responsablePrincipalPosicion: 0,
        nivelEnseñanza: new NivelEnseñanza(),
        establecimientos: [],
        numeroVinculacion: "",
        extras: new Extras()
      };
      return state;
    case 'reiniciarDatosResponsable':
      state = {
        responsables: []
      };
      return state;
    case 'calcularEdad':
      state.aspirante.edad = calcularEdad(state.aspirante.fechaNacimiento);
      return state;
    /*OTRAS ACCIONES*/

    default:
      return state;
  };
};

const calcularEdad = (dateString) => {
  const fechaNacimiento = new Date(dateString);
  const hoy = new Date();
  let edad = hoy.getFullYear() - fechaNacimiento.getFullYear();
  const diferenciaMeses = hoy.getMonth() - fechaNacimiento.getMonth();
  if (
    diferenciaMeses < 0 ||
    (diferenciaMeses === 0 && hoy.getDate() < fechaNacimiento.getDate())
  ) {
    edad--;
  };
  if (edad < 0) {
    return 0;
  } else {
    return edad;
  }
};

//VALORES MAXIMOS DE CAMPOS DE ENTRADA
const
  maxNombre = 200,
  maxApellido = 200,
  maxVinculo = 50,
  maxDocumentoNumero = 20,
  maxEmail = 50,
  maxTelefono = 10,
  maxCalle = 100,
  maxNumero = 10,
  maxPiso = 50,
  maxDepartamento = 50,
  maxLocalidad = 50;
//VINCULOS
const vinculos = [
  { nombre: "Madre", vinculoId: 1 },
  { nombre: "Padre", vinculoId: 2 },
  { nombre: "Tutor", vinculoId: 3 },
  { nombre: "Abuela/o", vinculoId: 4 }
]
//NIVELES
const niveles = [
  { nivel: "Inicial", grados: ["Sala de 4", "Sala de 5"] },
  { nivel: "Primario", grados: ["1º"] },
  { nivel: "Secundario", grados: ["1º"] },
];
function getPais(nombre) {
  let pos = 10;
  if (nombre) {
    paises.forEach((item, i) => {
      if (item.countryName === nombre) {
        pos = i;
      };
    });
  };
  return pos;
};
function getProvincia(nombre, pais) {
  let pos = 6;
  if (nombre) {
    paises[pais].regions.forEach((item, i) => {
      if (item.name === nombre) {
        pos = i;
      };
    });
  };
  return pos;
};
export const InscripcionUIProvider = ({ InscripcionUIEvents, children }) => {

  const [stateDatosPersonales, dispatchDatosPeronales] = useReducer(DatosPersonalesReducer, datosPersonalesBaseReducer);
  const [stateInscripciopnes, dispatchInscripciones] = useReducer(InscripcionesReducer, inscripcionesBaseReducer);
  //const [ultimoPaso, setUltimoPaso] = useState(1);
  const [posicion, setPosicion] = useState(0);
  
  const { aspirante } = useSelector(
    (state) => ({ aspirante: state.aspirante }),
    shallowEqual
  );
  const { aspiranteInformacion } = aspirante;

  const { pasoUno } = useSelector(
    (state) => ({ pasoUno: state.pasoUno }),
    shallowEqual
  );
  const { inscripcionId: inscripcionIdPasoUno, responsables: responsablesPasoUno, /*id: idPasoUno,*/ inscripcionNumero: inscripcionNumeroPasoUno } = pasoUno;

  const { inscripcion } = useSelector(
    (state) => ({ inscripcion: state.inscripcion }),
    shallowEqual
  );
  const {
    entities,
    listLoading,
    //actionsLoading,
    //error
  } = inscripcion;

  useEffect(() => {
    if (aspiranteInformacion) {
      const {
        id,
        nroDocumento: documentoNumero, sexo, nombre,
        apellido, fechaNacimiento, localidadNacimiento, paisNacimiento, provinciaNacimiento,
        domicilioId, domicilioCalle, domicilioDepartamento, domicilioLocalidad, domicilioNumero, domicilioPiso, domicilioDpto,
        personaRegistroCivilId, inscripcionNumero, inscripcionId, validadoPorElRegistroCivil,
        inscripcionVinculadaNumero, inscripcionVinculadaId
      } = aspiranteInformacion;
      const pais = getPais(paisNacimiento);
      stateDatosPersonales.aspirante = {
        id: id ? id : 0,
        documentoNumero,
        sexo,
        registroCivilvalidacion: true,
        validadoPorElRegistroCivil: validadoPorElRegistroCivil ? validadoPorElRegistroCivil : false,
        apellido,
        nombre,
        fechaNacimiento: new Date(fechaNacimiento),
        edad: calcularEdad(new Date(fechaNacimiento)),
        localidad: localidadNacimiento ? localidadNacimiento : stateDatosPersonales.aspirante.localidad,
        pais,
        provincia: getProvincia(provinciaNacimiento, pais),
        personaRegistroCivilId: personaRegistroCivilId ? personaRegistroCivilId : stateDatosPersonales.aspirante.personaRegistroCivilId,
        inscripcionNumero: inscripcionNumero ? inscripcionNumero : stateDatosPersonales.aspirante.inscripcionNumero,
        inscripcionId: inscripcionId ? inscripcionId : stateDatosPersonales.aspirante.inscripcionId,
        inscripcionVinculadaNumero: inscripcionVinculadaNumero ? inscripcionVinculadaNumero : stateDatosPersonales.aspirante.inscripcionVinculadaNumero,
        inscripcionVinculadaId: inscripcionVinculadaId ? inscripcionVinculadaId : stateDatosPersonales.aspirante.inscripcionVinculadaId,
      };
      stateDatosPersonales.aspirante.domicilio = {
        domicilioId: domicilioId ? domicilioId : 0,
        calle: domicilioCalle ? domicilioCalle : "",
        departamento: domicilioDepartamento ? domicilioDepartamento : "",
        localidad: domicilioLocalidad ? domicilioLocalidad : "",
        numero: domicilioNumero ? domicilioNumero : "",
        piso: domicilioPiso ? domicilioPiso : "",
        dpto: domicilioDpto ? domicilioDpto : "",
      };
    } else {
      dispatchDatosPeronales({ type: 'reiniciarDatos' });
    };
    /*console.log('ESTO ES LO QUE ESTA EN EL STATE ASPIRANTE:');
    console.log(aspiranteInformacion);
    console.log("ESTADO");
    console.log(stateDatosPersonales);*/
  }, [aspiranteInformacion])

  useEffect(() => {
    if (responsablesPasoUno) {
      stateDatosPersonales.aspirante.inscripcionId = inscripcionIdPasoUno ? inscripcionIdPasoUno : stateDatosPersonales.aspirante.inscripcionId;
      stateDatosPersonales.aspirante.inscripcionNumero = inscripcionNumeroPasoUno ? inscripcionNumeroPasoUno : stateDatosPersonales.aspirante.inscripcionNumero;
      responsablesPasoUno.forEach((item, i) => {
        if (!stateDatosPersonales.responsables[i]) {
          stateDatosPersonales.responsables[i] = new Responsable();
        };
        const { id, aspiranteResponsableId,
          nroDocumento: documentoNumero, sexo, nombre,
          apellido, fechaNacimiento, localidadNacimiento, paisNacimiento, provinciaNacimiento,
          domicilioId, domicilioCalle, domicilioDepartamento, domicilioLocalidad, domicilioNumero, 
          domicilioPiso, domicilioDpto,
          personaRegistroCivilId, validadoPorElRegistroCivil,
          vinculo, vinculoId, email, telefono
        } = item;
        const pais = getPais(paisNacimiento);
        dispatchDatosPeronales({
          type: 'guardarResponsableDocumentacion', 
          payload: {
            documentoNumero, sexo, posicion: i, personaRegistroCivilId, validadoPorElRegistroCivil, registroCivilvalidacion: true
          }
        });
        dispatchDatosPeronales({
          type: 'guardarResponsableDatosPersonales', 
          payload: {
            id: id ? id : 0,
            aspiranteResponsableId: aspiranteResponsableId ? aspiranteResponsableId : 0,
            nombre,
            apellido,
            fechaNacimiento: new Date(fechaNacimiento),
            edad: calcularEdad(new Date(fechaNacimiento)),
            pais,
            provincia: getProvincia(provinciaNacimiento, pais),
            localidad: localidadNacimiento ? localidadNacimiento : stateDatosPersonales.responsables[i].localidad,
            vinculo: vinculo ? vinculo : stateDatosPersonales.responsables[i].vinculo,
            vinculoId: vinculoId ? vinculoId : stateDatosPersonales.responsables[i].vinculoId,
            email: email ? email : stateDatosPersonales.responsables[i].email,
            telefono: telefono ? telefono : stateDatosPersonales.responsables[i].telefono,
            posicion: i
          }
        });
        const { domId, calle, numero, piso, dpto, departamento, localidad } = stateDatosPersonales.responsables[i].domicilio;
        dispatchDatosPeronales({
          type: 'guardarResponsableDomicilio', payload: {
            domicilioId: domicilioId ? domicilioId : domId,
            calle: domicilioCalle ? domicilioCalle : calle,
            numero: domicilioNumero ? domicilioNumero : numero,
            piso: domicilioPiso ? domicilioPiso : piso,
            dpto: domicilioDpto ? domicilioDpto : dpto,
            departamento: domicilioDepartamento ? domicilioDepartamento : departamento,
            localidad: domicilioLocalidad ? domicilioLocalidad : localidad,
            posicion: i
          }
        });
      })
    } else {
      dispatchDatosPeronales({ type: 'reiniciarDatosResponsable' });
    };
    /*console.log("ESTADO REDUX");
    console.log(responsablesPasoUno);
    console.log("ESTADO DESPUES DE CARGAR UN RESP");
    console.log(stateDatosPersonales);*/
  }, [responsablesPasoUno, inscripcionIdPasoUno, inscripcionNumeroPasoUno])

  useEffect(() => {
    if (!listLoading && entities) {
      let aux = entities.map(data => {
        return {
          id: data.id ? data.id : 0,
          inscripcionId: data.inscripcionId,
          inscripcionNumero: data.numero,
          nombre: data.aspiranteNombre,
          apellido: data.aspiranteApellido,
          documentoNumero: data.aspiranteNroDocumento,
          nivelEnsenanza: data.nivelEnsenanza,
          nivelEnsenanzaId: data.nivelEnsenanzaId,
          finalizada: data.finalizada,
          llamado: data.llamado,
          ultimoPasoEditado: data.ultimoPasoEditado,
        }
      });
      dispatchInscripciones({ type: 'cargarInscripciones', payload: aux })
    };
  }, [entities, listLoading]);

  const recomendacionInscripcion = () => {
    const fechaNacimiento = new Date(stateDatosPersonales.aspirante.fechaNacimiento);
    const hoy = new Date();
    if (fechaNacimiento === "") {
      return "";
    }
    if ((new Date(hoy.getFullYear() - 4, 6, 1) <= fechaNacimiento) && (fechaNacimiento < new Date(hoy.getFullYear() - 3, 6, 1))) {
      return "Nivel Inicial - Sala de 4";
    } else if ((new Date(hoy.getFullYear() - 5, 6, 1) <= fechaNacimiento) && (fechaNacimiento < new Date(hoy.getFullYear() - 4, 6, 1))) {
      return "Nivel Inicial - Sala de 5";
    } else if ((new Date(hoy.getFullYear() - 6, 6, 1) <= fechaNacimiento) && (fechaNacimiento < new Date(hoy.getFullYear() - 5, 6, 1))) {
      return "Nivel Primario";
    } else if (fechaNacimiento < new Date(hoy.getFullYear() - 11, 6, 1)) {
      return "Nivel Secundario";
    };
  };

  const nivelSeleccionado = () => {
    return stateDatosPersonales.nivelEnseñanza;
  };

  const validacionRegistroCivil = (p_tipo = "aspirante", p_posicion = 0) => {
    if (p_tipo === "aspirante") {
      return !!stateDatosPersonales.aspirante.personaRegistroCivilId && stateDatosPersonales.aspirante.personaRegistroCivilId > 0;
    } else {
      return !!stateDatosPersonales.responsables[p_posicion].personaRegistroCivilId && stateDatosPersonales.responsables[p_posicion].personaRegistroCivilId > 0;
    };
  };

  const cantidadResponsables = () => {
    let cantidad = 0;
    cantidad = stateDatosPersonales.responsables.length;
    return cantidad;
  };
  const obtenerResponsablePrincipal = () => {
    const i = stateDatosPersonales.responsablePrincipalPosicion;
    return stateDatosPersonales.responsables[i].apellido + ", " + stateDatosPersonales.responsables[i].nombre + " (" + stateDatosPersonales.responsables[i].vinculo + ")";
  };

  const responsablePrincipalPosicion = () => {
    return stateDatosPersonales.responsablePrincipalPosicion;
  };
  const verResponsables = () => {
    return stateDatosPersonales.responsables;
  };
  const verResponsable = (i) => {
    return stateDatosPersonales.responsables[i];
  };
  //OBTENCION DE VALORES
  const valoresDocumentacionResponsable = (i) => {
    if (cantidadResponsables() > i) {
      const valores = {
        sexo: stateDatosPersonales.responsables[i].sexo,
        documentoNumero: stateDatosPersonales.responsables[i].documentoNumero,
        personaRegistroCivilId: stateDatosPersonales.responsables[i].personaRegistroCivilId
      };
      return valores;
    } else {
      return new Documentacion();
    };
  };


  function valoresDatosPersonalesResponsable(i) {
    if (cantidadResponsables() > i) {
      const valores = {
        id: stateDatosPersonales.responsables[i].id,
        aspiranteResponsableId: stateDatosPersonales.responsables[i].aspiranteResponsableId,
        nombre: stateDatosPersonales.responsables[i].nombre,
        apellido: stateDatosPersonales.responsables[i].apellido,
        pais: stateDatosPersonales.responsables[i].pais,
        provincia: stateDatosPersonales.responsables[i].provincia,
        localidad: stateDatosPersonales.responsables[i].localidad,
        fechaNacimiento: stateDatosPersonales.responsables[i].fechaNacimiento,
        vinculo: stateDatosPersonales.responsables[i].vinculo,
        vinculoId: stateDatosPersonales.responsables[i].vinculoId,
        email: stateDatosPersonales.responsables[i].email,
        telefono: stateDatosPersonales.responsables[i].telefono,
      };
      return valores;
    } else {
      return new DatosPersonales();
    };
  };

  const valoresDomicilioResponsable = (i) => {
    if (cantidadResponsables() > i) {
      const valores = {
        domicilioId: stateDatosPersonales.responsables[i].domicilio.domicilioId,
        calle: stateDatosPersonales.responsables[i].domicilio.calle,
        numero: stateDatosPersonales.responsables[i].domicilio.numero,
        piso: stateDatosPersonales.responsables[i].domicilio.piso,
        dpto: stateDatosPersonales.responsables[i].domicilio.dpto,
        departamento: stateDatosPersonales.responsables[i].domicilio.departamento,
        localidad: stateDatosPersonales.responsables[i].domicilio.localidad,
      };
      return valores;
    } else {
      return new Domicilio();
    };
  };

  const valoresDocumentacionAspirante = () => {
    const { sexo, documentoNumero, personaRegistroCivilId, registroCivilvalidacion } = stateDatosPersonales.aspirante
    return { sexo, documentoNumero, personaRegistroCivilId, registroCivilvalidacion };
  };
  const valoresDatosPersonalesAspirante = () => {
    const { nombre, apellido, pais, provincia, localidad, fechaNacimiento } = stateDatosPersonales.aspirante;
    return { nombre, apellido, pais, provincia, localidad, fechaNacimiento };
  };

  const valoresDomicilioAspirante = () => {
    const { domicilioId, calle, numero, piso, dpto, departamento, localidad } = stateDatosPersonales.aspirante.domicilio;
    return { domicilioId, calle, numero, piso, dpto, departamento, localidad };
  };
  const valoresExtrasAspirante = () => {
    const { 
      id, personaRegistroCivilId, inscripcionNumero, inscripcionId, registroCivilvalidacion,
      inscripcionVinculadaNumero, inscripcionVinculadaId 
    } = stateDatosPersonales.aspirante;
    return { 
      id, personaRegistroCivilId, inscripcionNumero, inscripcionId, registroCivilvalidacion, 
      inscripcionVinculadaNumero, inscripcionVinculadaId 
    };
  };
  const valoresEstablecimientos = () => {
    return stateDatosPersonales.establecimientos;
  };
  const valoresExtras = () => {
    const { fueEstatal, fueAbanderaro, establecimientoBandera, establecimientoEstatal, inscripcionId } = stateDatosPersonales.extras;
    return { fueEstatal, fueAbanderaro, establecimientoBandera, establecimientoEstatal, inscripcionId };
  };

  const detalleAspirante = () => {
    return stateDatosPersonales.aspirante;
  };

  const detalleEstablecimientos = () => {
    return stateDatosPersonales.establecimientos;
  };
  const detalleNumeroVinculacion = () => {
    return stateDatosPersonales.numeroVinculacion;
  };
  const detalleExtras = () => {
    return stateDatosPersonales.extras;
  };

  // const confirmarInscripcion = () => {
  //   const { apellido, nombre, documentoNumero } = stateDatosPersonales.aspirante;
  //   //dispatchInscripciones({ type: 'guardarInscripcion', payload: { apellido, nombre, documentoNumero, inscripcionNumero: "325", estado: "Completa" } })
  // };
  const verInscripciones = () => {
    return stateInscripciopnes;
  };
  const verInscripcionesPorLlamado = () => {
    return stateInscripciopnes && _.groupBy(stateInscripciopnes, function (o) { return o.llamado; });
  };
  const cantidadInscripciones = () => {
    return stateInscripciopnes.length;
  };
  const verificarDNIS = (dni, sexo, posicion) => {
    let respuesta = false;
    if (stateDatosPersonales.aspirante.documentoNumero === dni && stateDatosPersonales.aspirante.sexo === sexo) {
      respuesta = true;
    };
    stateDatosPersonales.responsables.forEach((item, i) => {
      if (item.documentoNumero === dni && item.sexo === sexo && i !== posicion) {
        respuesta = true;
      };
    });
    return respuesta;
  };



  const value = {
    //REDUCERS
    stateDatosPersonales, dispatchDatosPeronales,
    stateInscripciopnes, dispatchInscripciones,

    //FUNCIONES
    validacionRegistroCivil,
    calcularEdad,
    verificarEntero,
    recomendacionInscripcion,
    cantidadResponsables,
    responsablePrincipalPosicion,
    obtenerResponsablePrincipal,

    verResponsables,
    verResponsable,
    nivelSeleccionado,
    //confirmarInscripcion,
    verInscripciones,
    verInscripcionesPorLlamado,
    cantidadInscripciones,
    setPosicion,
    posicion,
    verificarDNIS,
    //VALORES NIVELES
    niveles,


    //VALORES INICIALES PARA FORMIK
    valoresDocumentacionResponsable,
    valoresDatosPersonalesResponsable,
    valoresDomicilioResponsable,
    valoresDocumentacionAspirante,
    valoresDatosPersonalesAspirante,
    valoresDomicilioAspirante,
    valoresExtrasAspirante,
    valoresEstablecimientos,
    valoresExtras,

    //DETALLES DE LA INSCRIPCION PARA RESUMEN
    detalleAspirante,
    detalleEstablecimientos,
    detalleNumeroVinculacion,
    detalleExtras,

    //SEGUIMIENTO DE PASOS
    //ultimoPaso,
    //setUltimoPaso,
    //VALORES HARDCODEADOS
    vinculos,

    //VALORES MAXIMOS
    maxNombre,
    maxApellido,
    maxVinculo,
    maxDocumentoNumero,
    maxEmail,
    maxCalle,
    maxTelefono,
    maxNumero,
    maxPiso,
    maxDepartamento,
    maxLocalidad
  }

  return <PreInscripcionUIContext.Provider value={value} >{children}</PreInscripcionUIContext.Provider>
}